/**************************************时间格式化处理************************************/
const dateFtt = (fmt, date) => {
  var o = {
    "M+": date.getMonth() + 1, //月份 
    "d+": date.getDate(), //日 
    "h+": date.getHours(), //小时 
    "m+": date.getMinutes(), //分 
    "s+": date.getSeconds(), //秒 
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
    "S": date.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

export const dateFormatFn = (s, type) => {
  if (s == '' || s == null) {
    return '--'
  }
  const date = s.toString().length == 10 ? new Date(parseInt(s) * 1000) : new Date(parseInt(s));
  return type ? dateFtt("yyyy-MM-dd", date) : dateFtt("yyyy-MM-dd hh:mm:ss", date);
}
export const dateFormat = (s) => {
  if (s == '' || s == null) {
    return '--'
  }
  const date = s.toString().length == 10 ? new Date(parseInt(s) * 1000) : new Date(parseInt(s));
  return dateFtt("yyyy-MM-dd hh:mm:ss", date);
}

